import { render, staticRenderFns } from "./RatioModal.vue?vue&type=template&id=2b2b69ba&scoped=true&"
import script from "./RatioModal.vue?vue&type=script&lang=js&"
export * from "./RatioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b69ba",
  null
  
)

export default component.exports